import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import AsyncSelect from 'react-select/async';

const selectStyle = {
    theme: theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: '#92278f',
            primary: '#92278f',
        },
    })
};

const MoveClassRoomModal = ({ show, onClose, onSubmit, promiseClassRoomOptions, t }) => {
    const classRoomSelectRef = useRef(null);

    if (!show) return null;

    const handleSaveClassRoom = () => {
        const selected = classRoomSelectRef.current?.select?.select?.getValue();
        const value = selected && selected[0]?.value;
        onSubmit(value);
    };

    return (
        <Modal size="md" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-exchange text-primary icon ml-2"></i>
                        {t("Pages.StudentInClassRoomsControl.action.move")}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category mb-2">
                    <div className="widget-body">
                        <div className="form-group w-100">
                            <AsyncSelect
                                cacheOptions
                                isClearable={true}
                                name="ClassRoomId"
                                placeholder={t('Pages.ClassRoomsControl.title')}
                                isRtl={true}
                                isSearchable={true}
                                defaultOptions
                                loadOptions={promiseClassRoomOptions}
                                ref={classRoomSelectRef}
                                {...selectStyle}
                            />
                        </div>
                        <div className="form-group w-100 text-center">
                            <button className="custom-button btn-block" onClick={handleSaveClassRoom}>
                                <span>
                                    <i className="icon fal fa-exchange ml-1"></i>
                                    {t('Pages.StudentInClassRoomsControl.action.move_action')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MoveClassRoomModal;
